const bigMenu = document.querySelector('.js-big-menu');
const bigMenuItems = [...bigMenu.getElementsByClassName('js-big-menu-item')]

bigMenu.addEventListener('mouseleave', () => {
  bigMenu.classList.remove('big-menu--open')
  bigMenuItems.forEach((item) => item.classList.remove('is-active'))
})

bigMenuItems.forEach((item) => {
  item.addEventListener('mouseenter', () => {
    bigMenu.classList.add('big-menu--open')
    bigMenuItems.forEach((item) => item.classList.remove('is-active'))
    item.classList.add('is-active')
  })
})
